document.addEventListener('alpine:init', () => {
    window.Alpine.data('accordionTabs', (data) => ({
        tabs: data.tabs || [],
        activeTabs: data.activeTabs || [],
        lastActiveTab: data.lastActiveTab || null,
        allowMultipleActive: data.allowMultipleActive || false,
        init() {
            if (!data.activeTabs) {
                if (this.allowMultipleActive) {
                    this.activeTabs = this.tabs
                } else {
                    this.activeTabs = [this.tabs[0]]
                }
            }

            if (typeof data.lastActiveTab === 'undefined') {
                [this.lastActiveTab] = this.tabs
            }

            // After the defaults, so a link to a tab (#cad from the email verification link or Log In to Download,
            // #spec) opens that tab instead of being reset to the first one
            this.checkHash()

            this.observe()
        },

        openTab(tab) {
            if (!this.activeTabs.includes(tab)) {
                this.activeTabs.push(tab)
            }

            if (!this.allowMultipleActive) {
                this.activeTabs = this.activeTabs.slice(-1)
            }

            this.lastActiveTab = tab
            this.fixScroll(tab)
        },

        closeTab(tab) {
            this.activeTabs = this.activeTabs.filter((activeTab) => activeTab !== tab)
            this.fixScroll(tab)
        },

        toggleTab(tab) {
            this.lastActiveTab = tab

            if (this.activeTabs.includes(tab)) {
                this.closeTab(tab)
            } else {
                this.openTab(tab)
            }
        },

        fixScroll(tab) {
            // Fixes safari issue that scrolls the user down after clicking a tab below the current active tab
            const tabElement = document.getElementById(tab)
            if (!tabElement) return
            const tabElementTop = tabElement.getBoundingClientRect().top

            setTimeout(() => {
                window.scrollTo({
                    top: document.documentElement.scrollTop + tabElement.getBoundingClientRect().top - tabElementTop,
                    behavior: 'instant',
                })
            }, 1)
        },

        checkHash() {
            const tab = window.location.hash.substring(1)
            this.scrollToTab(tab)
        },

        scrollToTab(tab) {
            if (this.tabs.includes(tab)) {
                this.openTab(tab)

                const tabElement = document.getElementById(tab)
                if (tabElement) {
                    setTimeout(() => {
                        tabElement.scrollIntoView({ behavior: 'smooth' })
                    }, 1)
                }
            }
        },

        observe() {
            this.tabs.forEach((tab) => {
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) return

                        this.tabView(tab)
                        observer.disconnect()
                    })
                })

                const element = document.querySelector(`#${tab}-panel`)

                if (element) {
                    observer.observe(element)
                }
            })
        },

        tabView(tab) {
            window.dispatchEvent(new CustomEvent('gtmdata', {
                detail: {
                    event: 'gtm_tab_view',
                    payload: {
                        tab,
                    },
                },
            }))
        },
    }))
})
